import { put } from "redux-saga/effects";
import * as actions from "../actions";

export function* fetchQuestionsSaga(action) {
  const endpoint = `https://programming-quiz-kmaran-default-rtdb.firebaseio.com/${action.payload.moduleName}.json`;
  yield put(actions.fetchQuestionsInProgress());
  try {
    const response = yield fetch(endpoint);
    const data = yield response.json();
    let questions = yield Object.keys(data).map(
      (key) => data[key].questions
    )[0];
    yield questions.sort(() => Math.random() - 0.5);
    questions = yield questions.splice(0, 10);
    yield put(
      actions.fetchQuestionsSuccess(questions, action.payload.moduleName)
    );
  } catch (error) {
    yield put(actions.fetchQuestionsFailed(error.message));
  }
}
